module.exports = __webpack_public_path__ + "static/media/tony-kornheiser.4c8d45fc.png";